import React, { useEffect, useState } from 'react'
import JsonViewModal from '../../viewJson'
import Colors from './Colors/Colors'
import Descriptions from './Descriptions/Descriptions'
import HeaderExpandedRecord from './header/HeaderExpandedRecord'
import Images from './Images/Images'
import PriceHistory from './PricesHistory/PriceHistory'
import RawCategories from './RawCategories/RawCategories'
import Reviews from './Reviews/Reviews'
import Sizes from './Sizes/Sizes'
import Skus from './Skus/Skus'
import styles from './styles.module.css'
import Taxonomy from './Taxonomy/Taxonomy'
import Quantities from './Quantities/Quantities'
import ProductDetails from './ProductDetails/ProductDetails'
import Features from './Features/Features'
import useStore from '../ProductStore/Store' // Import product store
import { useHistory } from 'react-router-dom'
import BaseAlert from '../../Snackbar/NewImplementations/BaseAlert/BaseAlert'
import useEscapeKey from '../../utils/useEscapeKey'

function ExpandedRecordsProduct ({
  recordData,
  onClose,
  isLoadingRecord,
  errorNotEnoughCredits,
  setErrorNotEnoughCredits,
  snackBarStateError
}) {
  const history = useHistory()
  const { setShouldRefetch } = useStore()
  const [isVisible, setIsVisible] = useState(false)
  const [isJsonModalVisible, setIsJsonModalVisible] = useState(false) // State for JSON modal visibility
  const toggleJsonModal = () => {
    setIsJsonModalVisible(true)
  }
  const [record, setRecord] = useState(recordData) // Manage record as internal state

  const [errorAlert, setErrorAlert] = useState({
    open: false,
    title: '',
    body: '',
    color: ''
  })

  useEffect(() => {
    // Trigger the slide-in effect when the component mounts
    if (record || isLoadingRecord) {
      const timeoutId = setTimeout(() => {
        setIsVisible(true)
      }, 1)
      return () => clearTimeout(timeoutId)
    }
  }, [record, isLoadingRecord])

  const handleClose = () => {
    if (!isJsonModalVisible) {
      // Start the slide-out effect
      setIsVisible(false)
      // Use a timeout to match the CSS transition duration
      setTimeout(() => {
        onClose()
      }, 250)
    }
  }

  useEscapeKey(handleClose)

  useEffect(() => {
    setRecord(recordData)
    setShouldRefetch(true)
  }, [recordData, setShouldRefetch])

  useEffect(() => {
    if (snackBarStateError) {
      setErrorAlert({
        open: true,
        title: 'Requesting too many records',
        body: "The number of records you're requesting exceeds the available records remaining on your plan. Try narrowing your search or upgrade your account for more record credits.",
        color: '#000000'
      })
    }
    if (errorNotEnoughCredits) {
      setErrorNotEnoughCredits(false)
    }
  }, [snackBarStateError, errorNotEnoughCredits, setErrorNotEnoughCredits])

  if (isLoadingRecord || !record) {
    return (
      <div className={styles.modalBackdropExpandedRecord} onClick={handleClose}>
        <div
          className={styles.modalContentExpandedRecord}
          style={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            transform: isVisible ? 'translateX(0)' : 'translateX(100%)'
          }}
          onClick={e => e.stopPropagation()}
        >
          <p>Loading details...</p>
        </div>

        <BaseAlert
          open={errorAlert.open}
          title={errorAlert.title}
          body={errorAlert.body}
          color={errorAlert.color}
          actions={[
            {
              label: 'Upgrade account',
              onClick: () => history.push('/settings/billing/subscription')
            },
            {
              label: 'Ok',
              onClick: () => setErrorAlert(prev => ({ ...prev, open: false }))
            }
          ]}
          onClose={() => setErrorAlert(prev => ({ ...prev, open: false }))}
          style={{ width: '320px' }}
        />
      </div>
    )
  }

  return (
    <div>
      <div className={styles.modalBackdropExpandedRecord} onClick={handleClose}>
        <div
          className={`${styles.modalContentExpandedRecord} ${
            isVisible ? styles.modalVisible : ''
          }`}
          onClick={e => e.stopPropagation()}
        >
          <HeaderExpandedRecord
            record={record}
            handleClose={handleClose}
            toggleJsonModal={toggleJsonModal}
          />

          <hr className={styles.hrStyles} />

          <Images record={record} />

          <hr className={styles.hrStyles} />

          <Descriptions record={record} />

          <hr className={styles.hrStyles} />
          <PriceHistory record={record} />
          <hr className={styles.hrStyles} />

          <Reviews record={record} />

          <hr className={styles.hrStyles} />
          <div style={{ display: 'flex', justifyContent: 'space-between' }}>
            <RawCategories record={record} />
            <Taxonomy record={record} />
          </div>

          <hr className={styles.hrStyles} />
          <div style={{ display: 'flex', justifyContent: 'space-between' }}>
            <Colors record={record} />
            <Sizes record={record} />
          </div>

          <hr className={styles.hrStyles} />
          <div
            style={{
              marginTop: '22px',
              marginBottom: '24px',
              display: 'flex',
              justifyContent: 'space-between'
            }}
          >
            <Skus record={record} />
            <Quantities record={record} />
          </div>

          <hr className={styles.hrStyles} />

          <ProductDetails record={record} />

          <hr className={styles.hrStyles} />
          <Features record={record} />
        </div>
      </div>

      {isJsonModalVisible && (
        <JsonViewModal
          jsonData={record}
          onClose={() => setIsJsonModalVisible(false)}
        />
      )}
    </div>
  )
}

export default ExpandedRecordsProduct
